import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import { appState } from './application-state.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
	appState
  }
});
